import { ISelectOption } from "./commonTypes";

export const genres = [
  "Rock",
  "Pop",
  "Country",
  "RnB",
  "Soul",
  "Lo-fi",
  "Hip Hop",
  "EDM",
  "Jazz",
  "Blues",
  "Classical",
  "Opera",
  "A Capella",
  "Heavy Metal",
  "Death Metal",
  "Reggae",
  "Afro pop",
  "Afro Beats",
  "Afro house",
  "Amapiano",
  "Rap",
  "Folk",
  "Latin",
  "Dancehall",
  "Grime",
  "Drum and Bass",
  "K-Pop",
  "J-Pop",
  "C-Pop",
  "Reggaeton",
  "Bhangra",
  "Goa Trance",
  "Psytrance",
  "Acid Trance",
  "Hard Trance",
  "Techno",
  "UK Hip Hop",
  "Trap",
  "Cloud Rap",
  "Conscious Hip Hop",
  "Crunk",
  "Drill",
  "Emo Rap",
  "Gangsta Rap",
  "Horrorcore",
  "Hyphy",
  "Latin",
  "UK Drill",
  "Jamaican Dancehall",
  "Alternative Rock",
  "Punk Rock",
  "Gospel",
  "House",
  "Hard House",
  "Instrumental",
  "Beats",
  "Grunge",
  "Pop rock",
  "Swing",
  "Electro Swing",
  "Alternative Rock",
  "Progressive Rock",
  "Soft Rock",
  "Type Beat",
  "Country Rock",
  "Christian Rock",
  "Gospel Rap",
  "Christian Rap",
  "Schlager",
  "Kwaito",
  "Kwaito House",
  "Zim Dancehall",
  "Chilled",
  "Relaxed",
  "Ambient",
  "Avantgarde ",
  "Bachata",
  "Balkan",
  "Black Metal",
  "Hardcore",
  "Britpop",
  "Irish Folk",
  "Dubstep",
  "Discofox",
  "Disco",
  "Dub",
  "Indie Rock",
  "Indie Pop",
  "Pop Rock",
  "Cinematic",
  "Minimal",
  "Backing Track",
  "Hip Hop Instrumental",
  "Vocals",
  "New Metal",
  "Garage",
  "UK Hip Hop",
  "UK Trap",
  "Volksmusik",
];

export const genresOptions: ISelectOption[] = genres.map((genre) => ({
  label: genre,
  value: genre,
}));
